
<template>
  <logisticstatus-component>
    <div class="animated fadeIn">
   
    <b-row >
       
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
         <!--  <div slot="header">
            <strong>Status Report</strong> 
             </div> -->


          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
          <b-row style="margin-top:-5%">
          
         <b-col md="12" class="my-1">
           
            <b-row class="form-group">


              <b-col sm="3">
                <div id='container' style="margin:50px auto 0; width:350px;"> 
                <br> 
                  <b-form-group label="Shipping Id : " :label-cols="4">
                 
                <vue-tags-input v-model="customer.shippingid" name="shippingid" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.shippingid') }" :tags="tags" @tags-changed="newTags => tags = newTags  " :avoidAddingDuplicates="avoidAddingDuplicates" :placeholder="placeholder" ref="taginput" v-bind:separators="[',', ';']"/>
                   <span class="badge badge-success1">&nbsp;</span>&nbsp;
                   <label :label-cols="4" >Unique Shipping Id</label><br>
                   <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                  </b-form-group>
                   <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('shippingid')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.shippingid')" class="help text-danger">{{ errors.first('form-1.shippingid') }}</span>
                      </b-input-group>
                </div>



              </b-col>

             
              <b-col sm="6">

                <div id='container' style="margin:50px auto 0; width:250px;">
                <br>     
                  <b-form-group label="Status:":label-cols="3" >
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.shipmentstatus') }" class="mySelectBox" :onclick="status()">
                    <option :value="selected">--Selected Status-</option>
                    <option value="PickDone">PickDone</option>
                    <option value="RTD">RTD</option>
                    <option value="DLV">DLV</option>
                  </b-form-select>
                </b-form-group>
                 <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('shipmentstatus')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.shipmentstatus')" class="help text-danger">{{ errors.first('form-1.shipmentstatus') }}</span>
                      </b-input-group>
                </div>
                               
              </b-col>

              <b-col sm="1" style="margin-top:7%">
                <b-button  size="md"  type="submit"  variant="primary"@click="showlist();"> Search</b-button>      
              </b-col>   

            </b-row>               
                         
          </b-col>      
        </b-row> 
      </b-form>
             
        <b-row class="mb-4">                  
           <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row>

      
                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination>
          </b-col>  

        </b-card>
       
      </b-col>
   
    </b-row><!--/.row-->
  </div>   

</logisticstatus-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
      data: [],
      checkedShipmentID:[],
      items:[],
      selected:'',
      isBusy: false,
      showSelectAll : true,
      allowCustomValue : true,
      agentid:[],
      statusoptions:[],
      value4:[],
      placeholder:"Add shippingid",
      customer: {},
      shippingid: '',
      tags: [],
      options: [],
      avoidAddingDuplicates:false,
      shipmentstatus:'',
   
      fields: { text: 'name', value: 'id' },
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
    };
  },
 
  computed: {
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    //this.displaydeliveryagent();
    
  },
  methods: {
    info(item, shipmentid,index, button) {

      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },



    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {
     // alert(" i m in ");
    
      this.$validator.validateAll(scope).then(result => {
        if (result) { 
         // alert(" i m in alert");         
          this.showlist();
        }
      });
    },
    showlist: function() {
       this.isBusy = true;
       var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
   
    var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        var csvObj = {

          shippingid:shipmentid,
          shipmentstatus:shipmentstatus
        };


          this.$http.post(`${CONSTANTS.API_URL}/FastBees/pushPickDoneStatus`,csvObj)
          .then(result => {
            if (result!=null) {
            //this.invalidshipppingid=result.body.invalid_shipment;
             //console.log(invalidshipppingid.invalid_shipment);
             this.isBusy = !this.isBusy;
             this.customer = {}
             this.tags=[];
             Utils.notify("Added successfully", "success");
            // if (result.body.returnvalue >0 ) {
            //   this.isBusy = !this.isBusy;
            //     this.customer = {}
            //     // this.items  = result.body.returnvalue;

            //     // this.totalRows = result.body.returnvalue.length;

            //    this.tags=[];
              
  
            //  //this.errors.clear('form-1')
            // }else{
             
            // Utils.notify('invalid shipment id', 'error')
            // }
            //this.$router.push('/reallocationpickup');
             

           // this.displaydata();
          } else {
           Utils.notify(results.body.returnvalue, "error");
           this.items  = result.body.returnvalue;
            this.tags=[];

          }

            
          })
          .catch(ex => {
            console.log("error-----", ex);
          });

    },

    

   

    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentfirstname+"  "+this.agentmaster[i].deliveryagentlastname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    status: function() {

    if(this.shipmentstatus=="PickDone")
     {

     var csvObj = {

          shipmentstatus:"PickDone"

        };

      }
      else if(this.shipmentstatus=="RTD")
      {

      var csvObj = {

        shipmentstatus:"RTD"

      };

      }
       else if(this.shipmentstatus=="DLV")
      {

      var csvObj = {

        shipmentstatus:"DLV"

      };

      }
     },


  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}

@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
.addpad{
  padding: 10px;
}        
</style>

